export const PROJECT_STATUSES = ["Planning", "Active", "On Hold", "Completed", "Cancelled"];
export const TASK_STATUSES = ["To Do", "In Progress", "Under Review", "Blocked", "Done"];
export const TASK_PRIORITIES = ["Low", "Medium", "High", "Critical"];
export const SYSTEM_ROLES = ["Admin", "Project Manager", "Architect", "Engineer", "Site Worker", "Client"];
export const DOC_CATEGORIES = ["Architectural", "Structural", "Permits", "Mechanical", "Electrical", "Other"];

export const STATUS_COLOR = {
  "To Do": "#64748B",
  "In Progress": "#3B82F6",
  "Under Review": "#F59E0B",
  Blocked: "#EF4444",
  Done: "#10B981",
};

export const PRIORITY_COLOR = {
  Low: "#64748B",
  Medium: "#3B82F6",
  High: "#F59E0B",
  Critical: "#EF4444",
};

export const PROJECT_STATUS_COLOR = {
  Planning: "#94A3B8",
  Active: "#10B981",
  "On Hold": "#F59E0B",
  Completed: "#3B82F6",
  Cancelled: "#EF4444",
};

export function money(value, currency = "USD") {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `$${n.toLocaleString()}`;
  }
}

export function moneyExact(value, currency = "USD") {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function fileSize(bytes) {
  const b = Number(bytes || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / (1024 * 1024)).toFixed(2)} MB`;
}

export function initials(first, last) {
  return `${(first || "?")[0] || ""}${(last || "")[0] || ""}`.toUpperCase();
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString();
}
